<mat-checkbox
	class="ps-3 toggleAllAlerts"
	[ngClass]="{
		'mb-3': showAllAlerts,
	}"
	*ngIf="isAnyNonActiveAlert"
	[(ngModel)]="showAllAlerts"
	(ngModelChange)="filterAlerts()"
	>Pokaż wszystkie alerty
</mat-checkbox>
<div class="alerts-wrapper d-flex flex-column" *ngIf="alerts?.length">
	<div
		class="alert alert-danger d-flex flex-row justify-content-between align-items-center"
		*ngFor="let alert of alerts"
	>
		<p class="m-0">
			{{ alert.alert.name }}
		</p>
		<span>
			<i
				class="fas fa-user-pen me-3"
				*ngIf="alert.modifiedBy !== null"
				[matTooltip]="getModifiedByTooltipMessage(alert)"
			></i>
			<i
				class="fas"
				role="button"
				[ngClass]="{
					'fa-eye': !alert.active,
					'fa-eye-slash': alert.active,
				}"
				(click)="toggleActive(alert)"
				[matTooltip]="alert.active ? 'Ustaw jako niewidoczny' : 'Ustaw jako widoczny'"
			></i>
		</span>
	</div>
</div>
